import Vue from "vue";
import Router from "vue-router";
import { store } from "./store";
import url from "./service/base-url";
import checkPermission from "./service/checkPermission";
import { storage } from "./service/storage";
import { Message } from 'element-ui';

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("./views/Home.vue"),
      children: [
        {
          path: "",
          name: "home",
          component: () => import("./views/HomeIndex.vue"),
          meta: { title: "渔管理" }
        },
        {
          path: "setting/baseSetting",
          component: () =>
            import("./components/setting/companyManagement/baseSetting/BaseSetting.vue"),
          meta: {
            menuId: "1808071001030000130",
            title: "基地设置"
          },
          children: [
            {
              path: "/",
              name: "baseSetting",
              component: () =>
                import("@/components/setting/companyManagement/baseSetting/BaseSetting.vue"),
              meta: { title: "基地设置" }
            },
            {
              path: "baseSettingAdd",
              name: "baseSettingAdd",
              component: () =>
                import("@/components/setting/companyManagement/baseSetting/BaseSettingAdd.vue"),
              meta: { title: "增加基地设置" }
            },
            {
              path: "baseSettingEdit",
              name: "baseSettingEdit",
              component: () =>
                import("@/components/setting/companyManagement/baseSetting/BaseSettingEdit.vue"),
              meta: { title: "编辑基地设置" }
            }
          ]
        },
        {
          path: "setting/pondSetting",
          name: "pondSetting",
          component: () =>
            import("@/components/setting/companyManagement/pondSetting/PondSetting.vue"),
          meta: {
            menuId: "1808071002370000130",
            title: "塘口设置"
          },
          children: [
            {
              path: "pondSettingAdd",
              name: "pondSettingAdd",
              component: () =>
                import("@/components/setting/companyManagement/pondSetting/PondSettingAdd.vue"),
              meta: { title: "增加塘口设置" }
            },
            {
              path: "pondSettingEdit",
              name: "pondSettingEdit",
              component: () =>
                import("@/components/setting/companyManagement/pondSetting/PondSettingEdit.vue"),
              meta: { title: "编辑塘口设置" }
            }
          ]
        },
        {
          path: "setting/cultureBreed",
          name: "cultureBreed",
          component: () => import("@/components/setting/companyManagement/cultureBreed/CultureBreed.vue"),
          meta: { title: "养殖品种设置", menuId: "2606021410233706701" }
        },
        {
          path: "setting/plantSpecies",
          name: "plantSpecies",
          component: () => import("@/components/setting/companyManagement/plantSpecies/plantSpecies.vue"),
          meta: { title: "种植品种设置", menuId: "2606021410233706701" }
        },
        {
          path: "setting/personalAuthorityManagement",
          component: () =>
            import("@/components/setting/personalAuthorityManagement/PersonalAuthorityManagement.vue"),
          children: [
            {
              path: "roleSetting",
              name: "roleSetting",
              component: () =>
                import("@/components/setting/personalAuthorityManagement/RoleSetting.vue"),
              meta: { title: "角色设置" }
            },
            {
              path: "companyManagement",
              name: "companyManagement",
              component: () =>
                import("@/components/setting/personalAuthorityManagement/CompanyManagement.vue"),
              meta: { title: "公司人员管理" }
            },
            {
              path: "personnelAuthority",
              name: "personnelAuthority",
              component: () =>
                import("@/components/setting/personalAuthorityManagement/PersonnelAuthority.vue"),
              meta: { title: "员工权限" }
            },
            {
              path: "permissionAssignment",
              name: "permissionAssignment",
              component: () =>
                import("@/components/setting/personalAuthorityManagement/PermissionAssignment.vue"),
              meta: { title: "权限分配" }
            }
          ]
        },
        {
          path: "setting/PersonManagement",
          name: "PersonManagement",
          component: () => import("@/components/setting/personalAuthorityManagement/PersonManagement.vue"),
          meta: { title: "用户管理", menuId: "1903271615370000100" }
        },
        {
          path: "setting/companySetting",
          name: "companySetting",
          component: () => import("@/components/setting/companyManagement/companySetting/CompanySetting.vue"),
          meta: { title: "公司设置", menuId: "1904101402210000100" }
        },
        {
          path: "setting/purchaseUnit",
          name: "purchaseUnit",
          component: () => import("@/components/setting/purchaseUnit/PurchaseUnit.vue"),
          meta: { title: "购销单位", menuId: "1903271616340000100" }
        },
        {
          path: "setting/purchaseUnit/addPurchaseUnit",
          name: "addPurchaseUnit",
          component: () => import("@/components/setting/purchaseUnit/AddPurchaseUnit.vue"),
          meta: { title: "添加购销单位", menuId: "1903271616340000100" }
        },
        {
          path: "setting/purchaseUnit/editPurchaseUnit",
          name: "editPurchaseUnit",
          component: () => import("@/components/setting/purchaseUnit/EditPurchaseUnit.vue"),
          meta: { title: "编辑购销单位", menuId: "1903271616340000100" }
        },
        {
          path: "setting/materialSetting",
          name: "material",
          component: () => import("@/components/setting/materialSetting/Material.vue"),
          meta: { title: "物资管理", menuId: "1903271729290000100" }
        },
        {
          path: "setting/deviceManage",
          name: "deviceList",
          component: () => import("@/components/setting/deviceManage/DeviceList.vue"),
          meta: { title: "平板设备管理", menuId: "2606021441205546701" }
        },
        {
          path: "smartDevice/deviceManage",
          name: "deviceList",
          component: () => import("@/components/smartDevice/deviceManage/DeviceList.vue"),
          meta: { title: "设备管理", menuId: "2606041646421736701" }
        },
        {
          path: "smartDevice/alarmManage",
          component: () =>
            import("@/components/smartDevice/alarmManage/AlarmManagement.vue"),
          meta: { title: "报警管理", menuId: "2606041648561726701" },
          children: [
            {
              path: "/",
              name: "alarmList",
              component: () =>
                import("@/components/smartDevice/alarmManage/AlarmList.vue"),
              meta: { title: "报警管理", menuId: "2606041648561726701" }
            }
          ]
        },
        {
          path: "smartDevice/mapLocaltion",
          name: "mapLocaltion",
          component: () => import("@/components/smartDevice/MapLocaltion.vue"),
          meta: { title: "地图定位", menuId: "2606041704563326701" }
        },
        {
          path: "smartDevice/videoMonitor",
          name: "liveMonitor",
          component: () => import("@/components/smartDevice/VideoMonitor.vue"),
          meta: { title: "视频监控", menuId: "2606041707064626701" }
        },
        {
          path: "smartDevice/waterMonitorIndex",
          name: "waterMonitorIndex",
          component: () =>
            import("@/components/smartDevice/WaterMonitorIndex.vue"),
          meta: { title: "水质监测主页", menuId: "2606041701561346701" }
        },
        {
          path: '/tailWaterMonitoring',
          name: 'tailWaterMonitoring',
          meta: { title: "尾水监测", menuId: "2606041701561346701" },
          component: () => import('@/views/tailWaterMonitoring/tailWaterMonitoring.vue')
        },
        {
          path: "smartDevice/smartDevice",
          name: "smartDevice",
          component: () => import("@/components/smartDevice/SmartDevice.vue"),
          meta: { title: "智能设备" }
        },
        {
          path: "buyingAndSelling/fryPurchase",
          name: "fryPurchase",
          component: () => import("@/components/buyingAndSelling/fryPurchase/FryPurchase.vue"),
          meta: { menuId: "1808071004010000130", title: "渔苗采购" }
        },
        {
          path: "buyingAndSelling/fryPurchase/addFryPurchase",
          name: "addFryPurchase",
          component: () => import("@/components/buyingAndSelling/fryPurchase/AddFryPurchase.vue"),
          meta: { menuId: "1808071004010000130", title: "苗种采购单" }
        },
        {
          path: "buyingAndSelling/fishSales",
          name: "fishSales",
          component: () => import("@/components/buyingAndSelling/fishSales/FishSales.vue"),
          meta: { menuId: "1808071005420000130", title: "成鱼销售" }
        },
        {
          path: "buyingAndSelling/fishSales/addFishSales",
          name: "addFishSales",
          component: () => import("@/components/buyingAndSelling/fishSales/AddFishSales.vue"),
          meta: { menuId: "1808071005420000130", title: "成鱼销售单" }
        },
        {
          path: "buyingAndSelling/materialPurchase",
          name: "materialPurchase",
          component: () => import("@/components/buyingAndSelling/materialPurchase/MaterialPurchase.vue"),
          meta: { title: "物资采购" }
        },
        {
          path: "buyingAndSelling/materialPurchase/addMaterialPurchase",
          name: "addMaterialPurchase",
          component: () => import("@/components/buyingAndSelling/materialPurchase/AddMaterialPurchase.vue"),
          meta: { title: "物资采购单" }
        },
        {
          path: "buyingAndSelling/feedPurchase",
          name: "feedPurchase",
          component: () => import("@/components/buyingAndSelling/feedPurchase/FeedPurchase.vue"),
          meta: { title: "饲料采购", menuId: "2606041713310336701" }
        },
        {
          path: "buyingAndSelling/feedPurchase/addFeedPurchase",
          name: "addFeedPurchase",
          component: () => import("@/components/buyingAndSelling/feedPurchase/AddFeedPurchase.vue"),
          meta: { title: "饲料采购单", menuId: "2606041713310336701" }
        },
        {
          path: "buyingAndSelling/drugProcurement",
          name: "drugProcurement",
          component: () => import("@/components/buyingAndSelling/drugProcurement/DrugProcurement.vue"),
          meta: { title: "药品采购", menuId: "2606041716306936701" }
        },
        {
          path: "buyingAndSelling/drugProcurement/addDrugProcurement",
          name: "addDrugProcurement",
          component: () => import("@/components/buyingAndSelling/drugProcurement/AddDrugProcurement.vue"),
          meta: { title: "药品采购单", menuId: "2606041716306936701" }
        },
        {
          path: "buyingAndSelling/manureProcurement",
          name: "manureProcurement",
          component: () => import("@/components/buyingAndSelling/manureProcurement/ManureProcurement.vue"),
          meta: { title: "渔肥采购", menuId: "1903271731480000100" }
        },
        {
          path: "buyingAndSelling/manureProcurement/addManureProcurement",
          name: "addManureProcurement",
          component: () => import("@/components/buyingAndSelling/manureProcurement/AddManureProcurement.vue"),
          meta: { title: "渔肥采购单", menuId: "1903271731480000100" }
        },
        {
          path: "expense/costOriginValue",
          name: "costOriginValue",
          component: () => import("@/components/expense/costOriginValue/CostOriginValue.vue"),
          meta: { menuId: "2606041724146606701", title: "资产原值" }
        },
        {
          path: "expense/costOriginValue",
          component: () =>
            import("@/components/expense/costOriginValue/CostOriginValueManage.vue"),
          meta: {
            menuId: "2606041724146606701"
          },
          children: [
            {
              path: "addCostOriginValue",
              name: "addCostOriginValue",
              component: () =>
                import("@/components/expense/costOriginValue/AddCostOriginValue.vue"),
              meta: { title: "添加资产原值" }
            }
          ]
        },
        {
          path: "expense/assetsCalculation",
          component: () => import("@/components/expense/AssetsCalculation.vue"),
          meta: {
            menuId: "2606041727416016701",
            title: "资产计提"
          }
        },
        {
          path: "expense/expenseRecord",
          name: "expenseRecord",
          component: () => import("@/components/expense/expenseRecord/ExpenseRecord.vue"),
          meta: { menuId: "1810201522030000130", title: "费用支出" },
        },
        {
          path: "expense/expenseRecord/addExpenseRecord",
          name: "addExpenseRecord",
          component: () => import("@/components/expense/expenseRecord/AddExpenseRecord.vue"),
          meta: { menuId: "1810201522030000130", title: "费用支出单" },
        },
        {
          path: "expense/feeIncome",
          name: "feeIncome",
          component: () => import("@/components/expense/feeIncome/FeeIncome.vue"),
          meta: { menuId: "2606041729532346701", title: "费用收入" },
        },
        {
          path: "expense/feeIncome/addFeeIncome",
          name: "addFeeIncome",
          component: () => import("@/components/expense/feeIncome/AddFeeIncome.vue"),
          meta: { menuId: "2606041729532346701", title: "费用收入单" },
        },
        {
          path: "expense/costSummaryTable",
          component: () => import("@/components/expense/CostSummaryTable.vue"),
          meta: {
            menuId: "2606041731325216701",
            title: "费用分摊汇总表"
          }
        },
        {
          path: "expense/expenseSetting",
          name: "expenseSetting",
          component: () => import("@/components/expense/expenseSetting/ExpenseSetting.vue"),
          meta: { menuId: "1810201523450000130", title: "费用类型设置" },
        },
        {
          path: "expense/expenseSetting/detail",
          name: "ExpenseDetail",
          component: () => import("@/components/expense/expenseSetting/ExpenseDetail.vue"),
          meta: { menuId: "1810201523450000130", title: "费用设置" },
        },
        {
          path: "productionControl/productionPlan",
          meta: { menuId: "1904191539260000100", title: "生产计划" },
          name: "productionList",
          component: () => import("@/components/productionControl/productionPlan/productionList.vue"),
        },
        {
          path: "productionControl/cultureCycle",
          component: () =>
            import("@/components/productionControl/cultureCycleManagement/CultureCycle.vue"),
          meta: { menuId: "1808071007040000130", title: "养殖周期管理" },
          children: [
            {
              path: "cultureCycleAdd",
              name: "cultureCycleAdd",
              component: () =>
                import("@/components/productionControl/cultureCycleManagement/CultureCycleAdd.vue"),
              meta: { title: "增加养殖周期" }
            },
            {
              path: "cultureCycleEdit",
              name: "cultureCycleEdit",
              component: () =>
                import("@/components/productionControl/cultureCycleManagement/CultureCycleEdit.vue"),
              meta: { title: "编辑养殖周期" }
            },
            {
              path: "cultureCycleClear",
              name: "cultureCycleClear",
              component: () =>
                import("@/components/productionControl/cultureCycleManagement/CultureCycleClear.vue"),
              meta: { title: "查看清塘养殖周期" }
            }
          ]
        },
        {
          path: "productionControl/lossManagement",
          name: "loss",
          component: () => import("@/components/productionControl/lossManagement/Loss.vue"),
          meta: { menuId: "1808071008330000130", title: "损耗管理" },
        },
        {
          path: "productionControl/lossManagement/addLoss",
          name: "addLoss",
          component: () => import("@/components/productionControl/lossManagement/AddLoss.vue"),
          meta: { menuId: "1808071008330000130", title: "损耗记录单" },
        },
        {
          path: "productionControl/turnPondManagement",
          name: "turnPond",
          component: () => import("@/components/productionControl/turnPondManagement/TurnPond.vue"),
          meta: { menuId: "1808071010400000130", title: "转塘管理" },
        },
        {
          path: "productionControl/turnPondManagement/addTurnPond",
          name: "addTurnPond",
          component: () => import("@/components/productionControl/turnPondManagement/AddTurnPond.vue"),
          meta: { menuId: "1808071010400000130", title: "转塘记录单" },
        },
        {
          path: "productionControl/proofingManagement",
          name: "proofing",
          component: () => import("@/components/productionControl/proofingManagement/Proofing.vue"),
          meta: { menuId: "1808071011460000130", title: "打样管理" },
        },
        {
          path: "productionControl/proofingManagement/addProofing",
          name: "addProofing",
          component: () => import("@/components/productionControl/proofingManagement/AddProofing.vue"),
          meta: { menuId: "1808071011460000130", title: "打样记录单" },
        },
        {
          path: "productionControl/waterQualityParameters/parameterInput",
          component: () =>
            import("./components/productionControl/waterQualityParameters/parameterInput/ParamsInputManagement.vue"),
          meta: {
            menuId: "1810201525230000130"
          },
          children: [
            {
              path: "/",
              name: "paramsInput",
              component: () =>
                import("@/components/productionControl/waterQualityParameters/parameterInput/ParamsInput.vue"),
              meta: { title: "参数录入" }
            },
            {
              path: "addParamsInput",
              name: "addParamsInput",
              component: () =>
                import("@/components/productionControl/waterQualityParameters/parameterInput/AddParamsInput.vue"),
              meta: { title: "增加参数录入" }
            },
            {
              path: "editParamsInput",
              name: "editParamsInput",
              component: () =>
                import("@/components/productionControl/waterQualityParameters/parameterInput/EditParamsInput.vue"),
              meta: { title: "编辑参数录入" }
            }
          ]
        },
        {
          path: "productionControl/waterQualityParameters/parameterLine",
          name: "parameterLine",
          component: () => import("@/components/productionControl/waterQualityParameters/parameterLine/ParameterLine.vue"),
          meta: {
            menuId: "1810201527020000130",
            title: "参数曲线"
          },
        },
        {
          path: "productionControl/feedingManagement",
          name: "feeding",
          component: () => import("@/components/productionControl/feedingManagement/Feeding.vue"),
          meta: { menuId: "1808071012400000130", title: "投喂管理" },
        },
        {
          path: "productionControl/feedingManagement/feedingDetail",
          name: "feedingDetail",
          component: () => import("@/components/productionControl/feedingManagement/FeedingDetail.vue"),
          meta: { menuId: "2606041719228136701", title: "投喂管理明细" },
        },
        {
          path: "productionControl/feedingManagement/addFeeding",
          name: "addFeeding",
          component: () => import("@/components/productionControl/feedingManagement/AddFeeding.vue"),
          meta: { menuId: "1808071012400000130", title: "喂养记录单" },
        },
        {
          path: "productionControl/manureManagement",
          name: "manure",
          component: () => import("@/components/productionControl/manureManagement/Manure.vue"),
          meta: { menuId: "2606041721519496701", title: "渔肥管理" },
        },
        {
          path: "productionControl/manureManagement/addManure",
          name: "addManure",
          component: () => import("@/components/productionControl/manureManagement/AddManure.vue"),
          meta: { menuId: "2606041721519496701", title: "渔肥记录单" },
        },
        {
          path: "productionControl/preventionManagement",
          name: "prevention",
          component: () => import("@/components/productionControl/preventionManagement/Prevention.vue"),
          meta: { menuId: "1808071014060000130", title: "防疫防治" },
        },
        {
          path: "productionControl/preventionManagement/addPrevention",
          name: "addPrevention",
          component: () => import("@/components/productionControl/preventionManagement/AddPrevention.vue"),
          meta: { menuId: "1808071014060000130", title: "防疫防治记录单" },
        },
        {
          path: "qualityTracking",
          name: "qualityTracking",
          component: () =>
            import("@/components/qualityTracking/QualityTracking.vue"),
          meta: { title: "质量追溯" }
        },
        {
          path: "enterpriseBigData",
          name: "enterpriseBigData",
          component: () =>
            import("@/components/enterpriseBigData/EnterpriseBigData.vue"),
          meta: { title: "企业大数据平台", menuId: "1904191529230000100" }
        },
        {
          path: "bigDataPlatform",
          name: "bigDataPlatform",
          component: () =>
            import("@/components/bigDataPlatform/BigDataPlatform.vue"),
          meta: { title: "大数据运行平台" }
        },
        {
          path: "dataAnalyze/productionReport",
          name: "productionReport",
          component: () =>
            import("./components/dataAnalyze/ProductionReport.vue"),
          meta: { title: "生产报表", menuId: "1810201528470000130" }
        },
        {
          path: "dataAnalyze/estimatedOutputReport",
          name: "estimatedOutputReport",
          component: () =>
            import("./components/dataAnalyze/EstimatedOutputReport.vue"),
          meta: { title: "预估产出表", menuId: "1810201528470000130" }
        },
        {
          path: "dataAnalyze/productionProfitReport",
          name: "productionProfitReport",
          component: () =>
            import("./components/dataAnalyze/ProductionProfitReport.vue"),
          meta: { title: "生产利润表", menuId: "2606041733553286701" }
        },   
        {
          path: "dataAnalyze/fishAvgCostReport",
          name: "fishAvgCostReport",
          component: () =>
            import("./components/dataAnalyze/FishAvgCostReport.vue"),
          meta: { title: "鱼均费用报表", menuId: "2606041735344956701" }
        },
        {
          path: "dataAnalyze/storagePondReport",
          name: "storagePondReport",
          component: () =>
            import("./components/dataAnalyze/StoragePondReport.vue"),
          meta: { title: "预估存塘报表", menuId: "2606041737007846701" }
        },
        {
          path: "dataAnalyze/outPondReport",
          name: "outPondReport",
          component: () => import("./components/dataAnalyze/OutPondReport.vue"),
          meta: { title: "出塘报表", menuId: "1810201532150000130" }
        },
        {
          path: "dataAnalyze/lossReport",
          name: "lossReport",
          component: () => import("./components/dataAnalyze/LossReport.vue"),
          meta: { title: "损失报表", menuId: "1810201542580000130" }
        },
        {
          path: "dataAnalyze/goodLossSummaryReport",
          name: "goodLossSummaryReport",
          component: () =>
            import("./components/dataAnalyze/GoodLossSummaryReport.vue"),
          meta: { title: "物资耗用汇总表", menuId: "1810201545260000130" }
        },
        {
          path: "dataAnalyze/stockReport",
          name: "stockReport",
          component: () => import("./components/dataAnalyze/StockReport.vue"),
          meta: { title: "库存报表", menuId: "1904101406540000100" }
        },
        {
          path: "dataAnalyze/inOutReport",
          name: "inOutReport",
          component: () => import("./components/dataAnalyze/InOutReport.vue"),
          meta: { title: "收支报表", menuId: "2606041739396676701" }
        },
        {
          path: "dataAnalyze/inOutRank",
          name: "inOutRank",
          component: () => import("./components/dataAnalyze/InOutRank.vue"),
          meta: { title: "收支排行榜", menuId: "2606041741208946701" }
        },
        {
          path: "dataAnalyze/demo",
          name: "demo",
          component: () => import("./components/dataAnalyze/Demo.vue")
        },
        // 鱼塘租赁
        {
          path: "fishPondLease/property",
          name: "fishPondLeaseProperty",
          component: () =>
            import("@/components/fishPondLease/property/PropertyManage.vue"),
          meta: {
            title: "标的物管理",
            menuId: "2609241029273896701"
          }
        },
        {
          path: "fishPondLease/propertyDetail",
          name: "fishPondLeasePropertyDetail",
          component: () =>
            import("@/components/fishPondLease/property/PropertyDetail.vue"),
          meta: {
            title: "标的物详情",
            menuId: "2609241029273896701"
          }
        },
        {
          path: "fishPondLease/propertyAudit",
          name: "fishPondLeasePropertyAudit",
          component: () =>
            import(
              "@/components/fishPondLease/propertyAudit/PropertyAudit.vue"
            ),
          meta: {
            title: "标的物审核",
            menuId: "2609241035407526701"
          }
        },
        {
          path: "fishPondLease/tenant",
          name: "fishPondLeaseTenant",
          component: () =>
            import("@/components/fishPondLease/tenant/TenantManage.vue"),
          meta: {
            title: "承租方管理",
            menuId: "2609241048569116701"
          }
        },
        {
          path: "fishPondLease/tenantDetail",
          name: "fishPondLeaseTenantDetail",
          component: () =>
            import("@/components/fishPondLease/tenant/TenantDetail.vue"),
          meta: {
            title: "承租方详情",
            menuId: "2609241048569116701"
          }
        },
        {
          path: "fishPondLease/tenantAudit",
          name: "fishPondLeaseTenantAudit",
          component: () =>
            import("@/components/fishPondLease/tenantAudit/TenantAudit.vue"),
          meta: {
            title: "承租方审核",
            menuId: "2609241051064896701"
          }
        },
        {
          path: "fishPondLease/contract",
          name: "contractManage",
          component: () =>
            import("@/components/fishPondLease/contract/ContractManage.vue"),
          meta: {
            title: "合同管理",
            menuId: "2609241057550196701"
          }
        },
        {
          path: "fishPondLease/contractForm",
          name: "contractForm",
          component: () =>
            import("@/components/fishPondLease/contract/ContractForm.vue"),
          meta: {
            title: "合同编辑",
            menuId: "2609241057550196701"
          }
        },
        {
          path: "fishPondLease/contractDetail",
          name: "contractDetail",
          component: () =>
            import("@/components/fishPondLease/contract/ContractDetail.vue"),
          meta: {
            title: "合同详情",
            menuId: "2609241057550196701"
          }
        },
        {
          path: "fishPondLease/rent",
          name: "fishPondLeaseRent",
          component: () =>
            import("@/components/fishPondLease/rent/RentManage.vue"),
          meta: {
            title: "租金管理",
            menuId: "2609241059563666701"
          }
        },
        {
          path: "fishPondLease/contractTemplate",
          name: "fishPondLeaseTemplate",
          component: () =>
            import(
              "@/components/fishPondLease/contractTemplate/TemplateManage.vue"
            ),
          meta: {
            title: "合同模板管理",
            menuId: "2609241107222396701"
          }
        },
        {
          path: "fishPondLease/stat",
          name: "fishPondLeaseStat",
          component: () =>
            import("@/components/fishPondLease/stat/StatDashboard.vue"),
          meta: {
            title: "鱼塘汇总",
            menuId: "2609241102477666701"
          }
        },
        {
          path: "fishPondLease/config",
          name: "fishPondLeaseConfig",
          component: () =>
            import("@/components/fishPondLease/config/FeeConfig.vue"),
          meta: {
            title: "标的物配置",
            menuId: "2609241104128916701"
          }
        },
        {
          path: "403",
          component: () => import("./views/403.vue"),
          meta: { title: "无权限" }
        },
        {
          path: "noPermissions",
          component: () => import("./views/NoPermissions.vue"),
          meta: { title: "未分配权限" }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./components/login/Login.vue"),
      meta: { title: "登录" }
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      component: () => import("./views/unauthorized.vue"),
      meta: { title: "未认证" }
    },
    {
      path: "/switchingCompany",
      name: "switchingCompany",
      component: () => import("./views/SwitchingCompany.vue"),
      meta: { title: "切换公司中" }
    },
    {
      path: "/logincallback",
      name: "logincallback",
      component: () => import("./components/login/LoginCallback.vue"),
      meta: { title: "跳转中" }
    },
    {
      path: "/ylwLogout",
      name: "ylwLogout",
      component: () => import("./components/login/YlwLogout.vue"),
      meta: { title: "" }
    },
    {
      path: "/createFishery",
      name: "CreateFishery",
      component: () => import("./components/login/CreateFishery.vue"),
      meta: { title: "创建渔场" }
    },
    {
      path: "/changeFishery",
      name: "changeFishery",
      component: () => import("./components/login/ChangeFishery.vue"),
      meta: { title: "进入渔场" }
    },
    {
      path: "/backStage",
      component: () => import("@/components/backstage/BackStage.vue"),
      meta: { title: "渔联网后台管理" },
      children: [
        {
          path: "/",
          component: () =>
            import("@/components/backstage/fishManage/FishManage.vue"),
          children: [
            {
              path: "/",
              name: "InquiryCompany",
              component: () =>
                import("./components/backstage/fishManage/InquiryCompany.vue"),
              meta: { title: "设备列表" }
            },
            {
              path: "/userManage",
              name: "InquiryUser",
              component: () => import("./components/backstage/UserManage.vue"),
              meta: { title: "用户管理" }
            },
            {
              path: "/companyManage",
              name: "CompanyManage",
              component: () =>
                import("./components/backstage/CompanyManage.vue"),
              meta: { title: "公司管理" }
            },
            {
              path: "/withManage",
              name: "InquiryWith",
              component: () => import("./components/backstage/WithManage.vue"),
              meta: { title: "提现设置" }
            }
          ]
        }
      ]
    },
    {
      path: "/backEnd",
      component: () => import("@/components/backEnd/BackEndHome.vue"),
      meta: { title: "渔联网后台管理平台", menuId: "2606041743569996701" },
      children: [
        {
          path: "/",
          component: () =>
            import("@/components/backEnd/qualityTracing/QualityTracingManage.vue"),
          meta: { title: "质量追溯", menuId: "2606041743569996701" },
          children: [
            {
              path: "/",
              name: "qualityTracingList",
              component: () =>
                import("@/components/backEnd/qualityTracing/QualityTracingList.vue"),
              meta: { title: "质量追溯", menuId: "2606041743569996701" }
            },
            {
              path: "bindQualityTracingCode",
              name: "bindQualityTracingCode",
              component: () =>
                import("@/components/backEnd/qualityTracing/BindCode.vue"),
              meta: { title: "绑定追编码", menuId: "2606041743569996701" }
            },
            {
              path: "addQualityTracing",
              name: "addQualityTracing",
              component: () =>
                import("@/components/backEnd/qualityTracing/AddQualityTracing.vue"),
              meta: { title: "添加质量追溯", menuId: "2606041743569996701" }
            }
          ]
        },
        {
          path: "/backEnd/qualityCheckManage",
          component: () =>
            import("@/components/backEnd/qualityCheckManage/QualityCheckManage.vue"),
          meta: { title: "质检管理", menuId: "2606041745379806701" },
          children: [
            {
              path: "/",
              name: "qualityCheckList",
              component: () =>
                import("@/components/backEnd/qualityCheckManage/QualityCheckList.vue"),
              meta: { title: "质检管理", menuId: "2606041745379806701" }
            },
            {
              path: "addQualityCheck",
              name: "addQualityCheck",
              component: () =>
                import("@/components/backEnd/qualityCheckManage/AddQualityCheck.vue"),
              meta: { title: "添加质检管理", menuId: "2606041745379806701" }
            },
            {
              path: "editQualityCheck",
              name: "editQualityCheck",
              component: () =>
                import("@/components/backEnd/qualityCheckManage/EditQualityCheck.vue"),
              meta: { title: "编辑质检管理", menuId: "2606041745379806701" }
            }
          ]
        },
        {
          path: "/backEnd/driverManage",
          component: () =>
            import("@/components/backEnd/driverManage/DriverManage.vue"),
          meta: { title: "司机管理", menuId: "2606041747253626701" },
          children: [
            {
              path: "/",
              name: "driverList",
              component: () =>
                import("@/components/backEnd/driverManage/DriverList.vue"),
              meta: { title: "司机管理", menuId: "2606041747253626701" }
            },
            {
              path: "addDriver",
              name: "addDriver",
              component: () =>
                import("@/components/backEnd/driverManage/AddDriver.vue"),
              meta: { title: "添加司机管理", menuId: "2606041747253626701" }
            },
            {
              path: "editDriver",
              name: "editDriver",
              component: () =>
                import("@/components/backEnd/driverManage/EditDriver.vue"),
              meta: { title: "编辑司机管理", menuId: "2606041747253626701" }
            }
          ]
        },
        {
          path: "/backEnd/circulationBusinessManage",
          component: () =>
            import("@/components/backEnd/circulationBusinessManage/CirculationBusinessManage.vue"),
          meta: { title: "流通商管理", menuId: "2606041749162096701" },
          children: [
            {
              path: "/",
              name: "circulationBusinessList",
              component: () =>
                import("@/components/backEnd/circulationBusinessManage/CirculationBusinessList.vue"),
              meta: { title: "流通商管理", menuId: "2606041749162096701" }
            },
            {
              path: "addCirculationBusiness",
              name: "addCirculationBusiness",
              component: () =>
                import("@/components/backEnd/circulationBusinessManage/AddCirculationBusiness.vue"),
              meta: { title: "添加流通商管理", menuId: "2606041749162096701" }
            },
            {
              path: "editCirculationBusiness",
              name: "editCirculationBusiness",
              component: () =>
                import("@/components/backEnd/circulationBusinessManage/EditCirculationBusiness.vue"),
              meta: { title: "编辑流通商管理", menuId: "2606041749162096701" }
            }
          ]
        },
        {
          path: "/backEnd/certificateManage",
          component: () =>
            import("@/components/backEnd/certificateManage/CertificateManage.vue"),
          meta: { title: "证书管理", menuId: "2606041751463556701" },
          children: [
            {
              path: "/",
              name: "editCertificate",
              component: () =>
                import("@/components/backEnd/certificateManage/EditCertificate.vue"),
              meta: { title: "证书管理", menuId: "2606041751463556701" }
            }
          ]
        },
        {
          path: "/backEnd/reportManage",
          component: () =>
            import("@/components/backEnd/reportManage/index.vue"),
          meta: { title: "报告管理", menuId: "2606041753550366701" },
          children: [
            {
              path: "/",
              name: "reportList",
              component: () =>
                import("@/components/backEnd/reportManage/list.vue"),
              meta: { title: "报告管理", menuId: "2606041753550366701" }
            },
            {
              path: "addReport",
              name: "addReport",
              component: () =>
                import("@/components/backEnd/reportManage/addReport.vue"),
              meta: { title: "添加报告管理", menuId: "2606041753550366701" }
            },
            {
              path: "editReport",
              name: "editReport",
              component: () =>
                import("@/components/backEnd/reportManage/editReport.vue"),
              meta: { title: "编辑报告管理", menuId: "2606041753550366701" }
            }
          ]
        }
      ]
    },
    {
      path: "/nationalData",
      name: "nationalData",
      meta: {
        title: "企业实时运行平台"
      },
      component: () => import("./nationalData/Index.vue")
    },
    // {
    //   path: '/tailWaterMonitoring',
    //   name: 'tailWaterMonitoring',
    //   meta: { title: "尾水监测" },
    //   component: () => import('@/views/tailWaterMonitoring/tailWaterMonitoring.vue')
    // },
    {
      path: '/tailWaterMonitoringChart',
      name: 'tailWaterMonitoringChart',
      meta: { title: "尾水监测详情" },
      component: () => import('@/views/tailWaterMonitoring/tailWaterMonitoringChart.vue')
    },
    {
      path: '/farmMonitoring',
      name: 'farmMonitoring',
      meta: { title: "养殖场实时监测系统" },
      component: () => import('@/views/farmMonitoring/farmMonitoring.vue')
    },
    {
      path: "/productionProfitReport",
      name: "productionProfitReport2",
      component: () =>
        import("./components/dataAnalyze/ProductionProfitReport.vue"),
      meta: { title: "生产利润表", menuId: "2606041733553286701" }
    },
    {
      path: "/fishAvgCostReport",
      name: "fishAvgCostReport2",
      component: () =>
        import("./components/dataAnalyze/FishAvgCostReport.vue"),
      meta: { title: "鱼均费用报表", menuId: "2606041735344956701" }
    },
  ],
  // 固定路由跳转高度
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
/* eslint-disable*/
router.beforeEach(async (to, from, next) => {
  let pathArr = to.path.split('/')
  let fromArr = from.path.split('/')
  if((pathArr[2] !== fromArr[2])) {
    localStorage.setItem("pageNumber", 1);
  } else {
    localStorage.setItem("pageNumber", Number(localStorage.getItem("pageNumber")));
  }
  // console.log(pathArr[3], fromArr[3])
  // if(pathArr[3] === fromArr[3]) {
  //   console.log('xxx')
  //   localStorage.setItem("pageNumber", Number(localStorage.getItem("pageNumber")));
  // } else {
  //   console.log('xxxx')
  //   localStorage.setItem("pageNumber", 1);
  // }
  if (to.query.appid) {
    store.commit('setInQlw');
  }

  if (to.fullPath.indexOf('login') == -1) {
    storage.set('currentUrl', window.location.href);
  }

  if (to.name == 'smartDevice') {
    var win = window.open(url.smartDevice, '_blank');
    win.focus();
    return;
  }
  if (to.name == 'enterpriseBigData') {
    var win = window.open(url.enterpriseBigData, '_blank');
    win.focus();
    return;
  }
  // 智能设备水质参数主页
  if (to.name == 'waterMonitorIndex') {
    var win = window.open(url.waterQuality, '_blank');
    win.focus();
    next(from.path);
    return;
  }
  // 智能设备 地图定位
  if (to.name == 'mapLocaltion') {
    var win = window.open(url.mapLocation, '_blank');
    win.focus();
    next(from.path);
    return;
  }
   // 智能设备 监控
  if (to.name == 'liveMonitor') {
    var win = window.open(url.liveMonitor, '_blank');
    win.focus();
    next(from.path);
    return;
  }
 
  if (to.name == 'qualityTracingList' && from.name!== null && from.path.indexOf('backEnd')==-1) {
    window.open(url.pcQuantityUrl);
    // win.focus();
    return;
  }
  
  if (to.fullPath.indexOf('/login') == -1) {
    // 先拉公司信息，再拉用户信息，避免 checkNoPermissions 时 isQlwVersion 尚未就绪
    if (!store.state.curCompany.id) {
      await store.dispatch('getCurCompany');
    }
    if (!store.state.loginUser) {
      await store.dispatch('getLoginUser');
    }
  }
  if (
    !store.state.authorizedInfo &&
    to.fullPath.indexOf('/login') == -1 &&
    to.fullPath.indexOf('/createFishery') == -1 &&
    to.fullPath.indexOf('/switchingCompany') == -1
  ) {
    await store.dispatch('getAuthorizedInfo');
  }
  // if(store.state.visitedViews.some( item => item.path === to.path)) {
  //   return next();
  // }
  if(store.state.visitedViews.length >= 10){
    store.commit('DEL_VISITED_VIEWS', [{
      title: store.state.visitedViews[1].title,
      path: store.state.visitedViews[1].path,
      meta: {
        affix: false
      }
    }])

    // Message.error('最多同时可打开10个标签')
    // return next(from.path);
  }
  store.commit('PUSH_VISITED_VIEWS', {
    title: to.meta.title,
    path: to.path,
    fullPath: to.fullPath,
    meta: {
      affix: false
    }
  })
  next();
});

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
